import { isObject } from '../isServiceError';
import { isDataFetchingError } from '../DataFetchingError';
export class RedirectionInProgressFilter {
  constructor() {
    this.message = 'aborting: redirection in progress';
  }
  isLoggable(record) {
    const [maybeError] = record.messages;
    if (!(maybeError instanceof Error)) {
      return true;
    }
    const cause = maybeError.cause;
    if (isDataFetchingError(cause)) {
      return cause.extra.cause.statusText.toLowerCase().includes(this.message);
    }
    return !(isObject(cause) && 'message' in cause && typeof cause.message === 'string' && cause.message.toLowerCase().includes(this.message));
  }
}